import React from 'react';
import { IconProps } from './types';
import classes from './styledIcons.module.css';
import clsx from 'clsx';

export const HeadphonesIcon = (props: IconProps & { isInsideVerticalStepper?: boolean , isHorizontalForHoelt?: boolean }) => {
    const wrapperContainerClass = props.currentActive ? classes.iconBorderActive : classes.iconBorderInactive;
    const wrapperClass = props.isDone ? classes.active : classes.inactive;
    const iconBGFillClass = props.isDone ? classes.iconBGActive : classes.iconBGInactive;

    const getIconStatus = () => (props.isDone ? classes.iconColorActive : classes.iconColorInactive);

    const iconFillClass = props.isInsideVerticalStepper
        ? classes['vertical-stepper-icon-color-active']
        : getIconStatus();

    return (
        <div
            className={clsx(
                props.isInsideVerticalStepper ? classes['wrapper-inside-vertical-stepper'] : classes.wrapperContainer,
                wrapperContainerClass,
            )}
        >
            <div
                className={clsx(
                     ( props.isHorizontalForHoelt) ? classes['icon-wrapper-horizontal-for-hoelt'] : classes.wrapper,
                    props.isInsideVerticalStepper ? classes['icon-wrapper-inside-vertical-stepper'] : wrapperClass,
                )}
                style={{ justifyContent: 'center' }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={props.isInsideVerticalStepper ? '24' : '24'}
                    height={props.isInsideVerticalStepper ? '24' : '24'}
                    viewBox=".5 1 24 24"
                    fill="none"
                >
                    <mask
                        id="mask0_10709_4920"
                        style={{ maskType: 'alpha' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="25"
                        height="24"
                    >
                        <rect x="0.5" width="24" height="24" fill="#D9D9D9" className={iconBGFillClass} />
                    </mask>
                    <g mask="url(#mask0_10709_4920)">
                        <path
                            d="M9.5 21H3.5V12C3.5 10.75 3.7375 9.57917 4.2125 8.4875C4.6875 7.39583 5.32917 6.44583 6.1375 5.6375C6.94583 4.82917 7.89583 4.1875 8.9875 3.7125C10.0792 3.2375 11.25 3 12.5 3C13.75 3 14.9208 3.2375 16.0125 3.7125C17.1042 4.1875 18.0542 4.82917 18.8625 5.6375C19.6708 6.44583 20.3125 7.39583 20.7875 8.4875C21.2625 9.57917 21.5 10.75 21.5 12V21H15.5V13H19.5V12C19.5 10.05 18.8208 8.39583 17.4625 7.0375C16.1042 5.67917 14.45 5 12.5 5C10.55 5 8.89583 5.67917 7.5375 7.0375C6.17917 8.39583 5.5 10.05 5.5 12V13H9.5V21ZM7.5 15H5.5V19H7.5V15ZM17.5 15V19H19.5V15H17.5Z"
                            fill="white"
                            className={iconFillClass}
                        />
                    </g>
                </svg>
            </div>
        </div>
    );
};
